import { sample } from "rxjs/operators";

export class Equipment {
    constructor(private eq: any) {
        if (eq != null) {
            this.id = eq.id;
            this.equipmentid = eq.equipmentId;
            this.equipmentno = eq.equipmentNo;
            this.equipmenttypeid = eq.equipmentTypeId;
            this.capacity = eq.capacity;
            this.capacityuom = eq.capacityUom;
            this.engineclockhours = eq.engineClockHours;
            this.gatewayserialno = eq.gatewaySerialNo;
            this.imeino = eq.imeiNo;
            this.make = eq.make;
            this.model = eq.model;
            this.movementtypeid = eq.movementTypeId;
            this.movementname = eq.movementname;
            this.onboardeddate = eq.onboardedDate;
            this.commissiondate = eq.commissionDate;
            this.registrationnumber = eq.registrationNumber;
            this.simnosolution = eq.simNoSolution;
            this.workingstatus = eq.workingStatus;
            this.tobeonboarded = eq.tobeOnboarded;
            this.onboarderrordesc = eq.onboardErrorDesc;
            this.makename = '';
            this.modelname = '';
            this.sapEquipmentNo = eq.sapEquipmentNo;
            this.departmentalContractual = eq.departmentalContractual;
            this.equipmentContracterId = eq.equipmentContracterId;
            this.vendorCode = eq.vendorCode;
            this.productivityTph = eq.productivityTph;
            this.fuelEfficiencyLPH = eq.fuelEfficiencyLPH;
            this.equipmentName = eq.equipmentName;
            this.platformAssetId = eq.platformAssetId;
            this.equipmentLocalId = eq.equipmentLocalId;
            this.baseline = eq.baseLine;
            this.showFuel = eq.showFuel;
            this.isPayload = eq.isPayload;
            this.isCan = eq.isCan;
            this.fuellogdate = eq.fuelLogDate;
            this.payloadlogdate = eq.payloadLogDate;
            this.canlogdate = eq.canLogDate;
            this.gatewaySasTokenExpiry = eq.gatewaySasTokenExpiry;
            this.taggedGateway = eq.taggedGateway;
            this.gatewaySasToken = eq.gatewaySasToken;
            this.hmiSasTokenExpiry = eq.hmiSasTokenExpiry;
            this.taggedHmi = eq.taggedHmi;
            this.hmiSasToken = eq.hmiSasToken;
            this.runHrsMeasurePoint = eq.runHrsMeasurePoint;
            this.QueuingRadius = eq.queuingRadius;
            this.LoadingRadius = eq.loadingRadius;
        }
    }
    id: number;
    equipmenttypeid: number;
    equipmentid: string;
    equipmentno: number;
    make: string;
    model: string;
    capacity: string;
    capacityuom: string;
    movementtypeid?: number;
    movementname?: string;
    engineclockhours: number;
    commissiondate: Date;
    onboardeddate: Date;
    gatewayserialno: string;
    simnosolution: string;
    imeino: string;
    registrationnumber: string;
    workingstatus: boolean;
    createdby: number;
    modifiedby?: number;
    createddate: Date;
    modifieddate?: Date;
    tobeonboarded: boolean;
    onboarderrordesc: string;
    makename: string;
    modelname: string;
    sapEquipmentNo: string;
    departmentalContractual: string;
    equipmentContracterId?: number;
    vendorCode?: string;
    QueuingRadius?: any;
    LoadingRadius?: any;
    productivityTph?: string;
    fuelEfficiencyLPH?: any;
    equipmentName?: string;
    platformAssetId?: number;
    equipmentLocalId?: string;
    baseline: number;
    showFuel: boolean;
    isPayload: boolean;
    isCan: boolean;
    fuellogdate: Date;
    payloadlogdate: Date;
    canlogdate: Date;
    gatewaySasToken?: any;
    gatewaySasTokenExpiry?: any;
    taggedGateway?: any;
    hmiSasToken?: any;
    hmiSasTokenExpiry?: any;
    taggedHmi?: any;
    runHrsMeasurePoint?: any;
}

export class EquipmentSaveDetails {
    unitId?: number;
    id: number;
    equipmenttypeid: number;
    equipmentno: number;
    equipmentid?: string;
    make: number;
    model: number;
    capacity: string;
    capacityuom: string;
    movementtypeid?: number;
    engineclockhours: number;
    commissiondate: any;
    onboardeddate: any;
    gatewayserialno?: string;
    simnosolution?: string;
    imeino?: string;
    registrationnumber?: string;
    workingstatus: boolean;
    createdby: number;
    modifiedby?: number;
    createddate: Date;
    modifieddate?: Date;
    issinglesave: boolean;
    tobeonboarded: boolean;
    onboarderrordesc: string;
    isfileexist: boolean;

    sapEquipmentNo?: string;
    departmentalContractual: string;
    equipmentContracterId?: number;
    vendorCode?: string;
    QueuingRadius?: number;
    LoadingRadius?: number;
    platformAssetId?: number;
    productivityTph?: string;
    fuelEfficiencyLPH?: any;
    equipmentName?: string;
    baseLine?: number;
    showfuel?: boolean;
    ispayload?: boolean;
    iscan?: boolean;
    fuellogdate?: any;
    payloadlogdate?: any;
    canlogdate?: any;
    gatewaySasToken?: any;
    gatewaySasTokenExpiry?: any;
    taggedGateway?: any;
    hmiSasToken?: any;
    hmiSasTokenExpiry?: any;
    taggedHmi?: any;
    runHrsMeasurePoint?: any;
}

export class AddPopupEquipmentDetails {
    typeLabel: string;
    movementTypeList: any[];
    makeList: any[];
    modelList: any[];
    activeTab: string;
    selectedEquipmentType: number;
    capacityLabel: string;
    isMovementTypeVisible: boolean;
    isCapacityVisible: boolean;
    isRegNoVisible: boolean;
    contracterList: any[];
    equipmentidList: any[];
    gatewayList: any[];
    imeiList: any[];
    units: string;
}

export class EquipmentType {
    id: number;
    name: string;
    equipmentlist: Equipment[];
}

export enum EnumEquipmentType {
    Driller,
    Excavator,
    Dumper,
    WheelLoader,
    Dozer,
    MotorGrader,
    WaterSprinkler,
    RockBreaker,
    SoilCompactor
}

export const ConstEquipmentType = new Map<number, string>([
    [EnumEquipmentType.Driller, 'Driller'],
    [EnumEquipmentType.Excavator, 'Excavator'],
    [EnumEquipmentType.Dumper, 'Dumper'],
    [EnumEquipmentType.WheelLoader, 'Wheel Loader'],
    [EnumEquipmentType.Dozer, 'Dozer'],
    [EnumEquipmentType.MotorGrader, 'Motor Grader'],
    [EnumEquipmentType.WaterSprinkler, 'Water Sprinkler'],
    [EnumEquipmentType.RockBreaker, 'Rock Breaker'],
    [EnumEquipmentType.SoilCompactor, 'Soil Compactor'],
]);

export class FleetLevelInputModel {
    autoRefresh: boolean;
    autoRefreshTime: number;
    chartType?: string;
    filter: FilterInputModel;
    format?: string;
    isTile: boolean;
    legend: LegendModel;
    maxDecimalPoint: number;
    userDetails: UserDetails;
    xaxis: XaxisModel;
    yaxis: YaxisModel[];
}

export class FilterInputModel {
    aggregation?: string;
    custom: CustomDateModel;
    filtersData: FilterDataModel[];
    isCustom: boolean;
    timeRange?: string;
    timeRangeLabel?: string;
}

export class CustomDateModel {
    fromDate?: any;
    fromDisp?: any;
    to?: any;
    toDisp?: any;
}

export class FilterDataModel {

    id?: string;
    value: DataValueModel[];
}

export class DataValueModel {
    label?: string;
    value?: string;
}

export class LegendModel {
    position?: string;
    show?: boolean;
}

export class UserDetails {

    user_id?: string;
}

export class XaxisModel {
    aggregation?: string;
    format?: string;
    label: string;
    limit_results?: number;
    sort?: string;
    type?: string;
    tag: DataValueModel;
}

export class YaxisModel {
    aggregation?: string;
    name?: string;
    tag: DataValueModel;
}

export class TileBasedModel {
    totalProduction?: any;
    totalUtilization?: any;
    specFuelConsumption?: any;
    productionPerShift?: any;

    //units
    totalProdUnit?: UOMModel;
    totalUtilUnit?: UOMModel;
    specFuelUnit?: UOMModel;
    prodperShiftUnit?: UOMModel;

}

export class UOMModel {
    tag_id?: any;
    tag_name?: any;
    unit_name?: any;

}

export class EquipmentLevelInputModel extends FleetLevelInputModel {
    // inheriting the propertis of FleetLevelInputModel
}

export class TileBasedEquipmentModel extends TileBasedModel {
    idleHrs?: any;
    runningHrs?: any;
    tonnage?: any;
    avgPayload?: any;
    production?: any;
    Productivity?: any;
    fuelConsRate?: any;
    idle?: any;
    distanceTravelle?: any;
    fuelConsumptionHr?: any;
    fuelMT?: any;
    noOftrips?: any;
    fuelConsumption?: any;
    productivePercentage?: any;
    runningHours?: any;
    idleTime?: any;
    fuelRefill?: any;
    avgSpeed?: any;
}

export class TileBasedExcavatorEquipmentModel {
    totalUtilization?: any;
    specFuelConsumption?: any;
    travelPercentage?: any;
    fuelConsumpRate?: any;
    idleHrs?: any;
    runningHrs?: any;
    tonnage?: any;
    avgPayload?: any;
    noOfTrips?: any;
    productivity?: any;
    production?: any
    idle?: any;
    travel?: any;
    productivePercentage?: any;
    runningHours?: any;
    idleTime?: any;
    enginOff?: any;
}


export class TileBasedExcavatorFleetModel {
    totalUtilization?: string;
    runningHrs?: string;
    avgPayload?: string;
    travelPercentage?: string;
    productivity?: any;
    idle?: any;
    trips?: any;
    idleTime?: any;
}

export class TileBasedCrusherEquipmentModel {
    crusherRunHrs?: number;
    apronFeederRunHrs?: number;
    utilization?: number;
    productiveHrs?: string;
    productivity?: number;
    reject?: number;
    capacity?: number;
    production?: number;
    crusherStatus?: string;
    apronutilization?: number;
    apronStatus?: string;
    hopperLevel?: number;
}

export class TileBasedCBAEquipmentModel {
    rollingTPH?: number;
    rollingLSF?: number;
    rollingSM?: number;
    rollingTons?: number;
    moundLSF?: number;
    moundSM?: number;
    moundTons?: number;
    rollingLSF60?: number;
    rollingTons60?: number;
    rollingMgo?: number;
    rollingSM60?: number;
    rollingMgo60?: number;
}


export class ListDataInputModel {
    input_param?: string[];
}

export class DataResponseAssetTypeModel {
    label?: string;
    value?: Number;

}

export class AssetTypeResponseModel {
    asset_type: DataResponseAssetTypeModel[]
}

export class ModelsResponseModel {
    model: DataResponseAssetTypeModel[]
}

export class AssetResponseModel {
    asset: DataResponseAssetTypeModel[]

}

export class ShiftResponseModel {
    shift: DataResponseAssetTypeModel[]
}

export class MetaDataRequestModel {
    mine_id?: Number;
    type?: string;
    id?: Number;
}

export class MineDetails {
    Name?: string;
    Location?: string;
    TotalCapacity?: string;
    Total?: Number;
    MineId?: Number;
}

export class MineDetailsResponseModel {
    status?: string;
    data?: MineDetails[];
}

export class MineAssetDetails {
    Name?: string;
    DeviceId?: string;
    Location?: string;
    TotalCapacity?: string;
    Total?: Number;
    MineId?: Number;
}

export class MineAssetDetailsResponseModel {
    status?: string;
    data?: MineAssetDetails[];
}

export class CardMapViewDetailsRequestModel extends MetaDataRequestModel {

}

export class MapEquipments {
    equipment_id?: string;
    equipment_desc?: string;
    latitude?: Number;
    longitude?: Number;

}

export class MapEquipmentsResponseModel {
    status?: string;
    data?: MapEquipments[];
}

export class MapEquipmentDetails {
    equipment_id?: string;
    speed?: Number;
    payload?: Number;

}

export class MapEquipmentDetailsResponseModel {
    status?: string;
    data?: MapEquipmentDetails[];
}

export class EquipmentDetails {
    assetTypeNo?: number;
    equipmentno?: Number;
    speed?: Number;
    weight?: Number;
    utilization?: Number;
    production?: Number;
    fuel_consumption?: Number;
    production_shift?: Number;

}

export class EquipmentDetailsResponseModel {
    status?: string;
    data?: EquipmentDetails[];
}

export class MineStatus {
    total_no_of_equipments?: Number;
}

export class MineStatusResponseModel {
    status?: string;
    data?: MineStatus[];
}

export class AssetTypeDetailsRequestModel {
    mine_id?: Number;
}
export class AssetTypeDetails {
    AssetType: any[];
}

export class AssetTypeDetailsResponseModel {
    status?: string;
    data?: AssetTypeDetails;
}

export class RefreshedTime {
    last_data_refreshed_time?: string;
}
export class RefreshedTimeResponseModel {
    status?: string;
    data?: RefreshedTime;
}

export class FieldClass {
    FieldName?: string;
    FieldValue?: string;
}
export class EquipmentTypeResponseModel {
    assetTypeName: string;
    data: FieldClass[];
}
export class EquipmentTypeData {

    AssetType: EquipmentTypeResponseModel[];
}

export class EquipmentDetailForKpi {
    equipmentType: string;
    totalCount: number;
    totalCapacity: number;
}

export class EquipmentMakeModelModel {
    equipmentType: string;
    make: string;
    model: string;
    platformAssetId: string;
    equipmentId: string;
    capacity: string;
    equipmentLocalId: string;
}

// export class AddAssetModel
// {
//     platformAssetId: number;
//     assetTypeId: number;
//     customerId: number;
//     assetCustomerId: string;
//     location: number;
//     projectMapped: string;
//     description: string;
//     onboarded: Date;
//     status: boolean;
//     createdBy: string;
//     updatedBy: string;
//     childAssetType: number[];
//     locationData: string;
//     movableAssetData: string;
// }

export class AddAssetModel {
    assetTypeId: number;
    customerId: number;
    assetCustomerId: string;
    location: number;
    projectMapped: string;
    description: string;
    createdBy: string;
    childAssetType: string;
    locationData: string;
    movableAssetData: string;
}

export class AddAssetResponse {
    status: string;
    platformAssetId: number;
    message: string;
}

export class EquipmentMake {
    id: number;
    make: string;
    equipmentModel: EquipmentModel[];
}

export class EquipmentModel {
    id: number;
    model: string;
}

export class EquipmentActualModel {
    mine_id: number;
    from_date: string;
    to_date: string;
}

export class EquipmentActualResultModel {
    status?: string;
    data?: EquipmentActualDataResult;

}

export class EquipmentActualDataResult {
    total?: number;
    engine_on?: number;
    engine_off?: number;
    not_reporting?: number;
    productivity?: number;
    breakdown?: number;
}

export class EquipmentsResponseModel {
    status?: string;
    data?: MetadataEquipmentModel[];
}



export class MetadataEquipmentModel {
    // constructor(private c?: any) {
    //     this.asset_id = c.asset_id;
    //     this.asset_name = c.asset_name;
    //     this.asset_code = c.asset_code;


    // }
    asset_id?: string;
    asset_name?: string;
    asset_code?: string;
}

export class MetadataEquipmentInputModel {
    constructor(private c?: any) {
        this.from_date = c.from_date;
        this.to_date = c.to_date;
        this.asset_type = c.asset_type;
        this.status = c.status;
    }
    from_date: string;
    to_date: string;
    asset_type: string;
    status: string;
}

export class BreakDownEquipmentDetails {

    constructor(private c?: any) {
        if (c != null) {
            this.equipmentType = c.equipmentType;
            this.make = c.make;
            this.makeId = c.makeId;
            this.model = c.model;
            this.modelId = c.modelId;
            this.platformAssetId = c.platformAssetId;
            this.equipmentId = c.equipmentId;
            this.equipmentIdInt = c.equipmentIdInt;
            this.capacity = c.capacity;
            this.equipmentLocalId = c.equipmentLocalId;
        }
    }

    equipmentType?: string;
    make?: string;
    makeId?: Number;
    model?: string;
    modelId?: Number;
    platformAssetId?: string;
    equipmentId?: string;
    equipmentIdInt?: string;
    capacity?: string;
    equipmentLocalId?: string;

}

export class EquipmentMaintenanceBreakdownCountModel {
    constructor(equipmentMaintenanceCount?: number, equipmentBreakdownCount?: number, breakdownMaintenanceTotalCount?: number) {
        this.equipmentMaintenanceCount = equipmentMaintenanceCount;
        this.equipmentBreakdownCount = equipmentBreakdownCount;
        this.breakdownMaintenanceTotalCount = breakdownMaintenanceTotalCount;
    }
    equipmentMaintenanceCount?: number;
    equipmentBreakdownCount?: number;
    breakdownMaintenanceTotalCount?: number;

}

export class ShiftTypeDetails {
    constructor(private c?: any) {
        if (c != null) {
            this.id = c.id;
            this.name = c.name;
            this.fromTime = c.fromTime;
            this.toTime = c.toTime;
            this.order = c.order;

        }
    }
    id: number;
    name: string;
    fromTime: string;
    toTime: string;
    order?: number;
}


export class ShiftTypeResult {

    constructor(private q?: any) {
        if (q != null) {
            this.id = q.id;
            this.name = q.name;
            this.start = q.start;
            this.end = q.end;
            this.c = q.c

        }
    }

    c: ShiftTypeDetails;
    id: number;
    name: string;
    start: string;
    end: string;

}
export class dumperTypeListModel {
    id: number;
    name: string;
    controlname: string;
}
export class dumperGanttChartModel {

    id: string;
    name: string;
    startDate: Date;
    endaDate: Date;
    status: number;
    description: string;
}
export class allEquipmentDetails {
    // constructor(private c?:any)
    // {
    //     this.asset_id = c.asset_id;
    //     this.equipmentID = c.asset_name;
    //     this.sapID = c.asset_code;
    //     this.make = c.make;
    //     this.makeId = c.makeId;
    //     this.model = c.model;
    //     this.modelId = c.modelId;
    // }
    asset_id?: string;
    equipmentID?: string;
    sapID?: string;
    make?: string;
    makeId?: Number;
    model?: string;
    modelId?: Number;
    status?: string;
    assetName?: string;

}
export class EquipmentDataResult {
    AssetType: string;
    EquipmentId: number;
    AssetName: string;
    Utilization: number;
    Production: number;
    Trip: number;
    Productivity: number;
    Idle: any;
    Travel: number;
    RunningHours: string;
    ProductivePercentage: number;
    EquipmentStatus: string;
    EnginOff?: any;

}

export class summaryDataModel {
    runHours?: any;
    idleHours?: any
    production?: any;
    productivit?: any;
    trips?: any;
    utilization?: any;

}

